import { css } from 'emotion';
import L from 'leaflet';

import plannedStartIconUrl from '../icons/ic_start_planned.svg';

const icon = css`
    filter: drop-shadow(0px 4px 4px rgba(7, 7, 78, 0.2));
`;
const placeImage = `<img src="${plannedStartIconUrl}" />`;

export const PlannedStartIcon = new L.DivIcon({
  html: `<div class="${icon}">${placeImage}</div>`,
  iconSize: [27, 33],
  iconAnchor: [13.5, 33],
});
